var _path, _path2, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpinDiamondAsset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99,
    height: 95,
    viewBox: "0 0 99 95",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5353 94.0151L0.321289 33.6606L18.6935 0.211914H49.5353H80.4163L98.7882 33.6606L49.5353 94.0151Z",
    fill: "url(#paint0_linear_4786_67526)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3026 85.2529C51.8991 88.3899 47.1726 88.3889 44.7703 85.2509L7.16085 36.1224C5.69282 34.2047 5.51682 31.5941 6.71417 29.4968L19.819 6.54165C20.8875 4.66995 22.8773 3.51465 25.0326 3.51465H49.5352H74.0768C76.2321 3.51465 78.222 4.66996 79.2905 6.54168L92.3942 29.4952C93.592 31.5933 93.4153 34.205 91.946 36.1228L54.3026 85.2529Z",
    fill: "#9A562A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_4786_67526)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5711 81.8566C52.2027 85.4978 46.8709 85.4965 44.5044 81.8541L15.8246 37.7122C14.4688 35.6254 14.541 32.9184 16.0062 30.9068L30.2254 11.3858C31.3554 9.83453 33.1588 8.91699 35.078 8.91699H49.5358H64.0328C65.9519 8.91699 67.7554 9.83453 68.8853 11.3858L83.1032 30.9051C84.5691 32.9175 84.6407 35.6259 83.2832 37.713L54.5711 81.8566Z",
    fill: "url(#paint1_linear_4786_67526)"
  }))), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0327 74.2824C52.9261 79.0579 46.1493 79.0558 44.0458 74.2789L28.3484 38.6328C27.5208 36.7535 27.7112 34.5815 28.8532 32.8748L43.1005 11.5819C44.2147 9.9166 46.0863 8.91699 48.09 8.91699H49.5352H51.0196C53.0233 8.91699 54.8949 9.9166 56.0091 11.5819L70.2551 32.8727C71.3978 34.5806 71.5876 36.7542 70.7583 38.6343L55.0327 74.2824Z",
    fill: "#FFDDBD",
    fillOpacity: 0.28,
    style: {
      mixBlendMode: "soft-light"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4786_67526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.2248 13.8396L41.4863 12.6846H61.4698L62.8256 13.2736L43.2248 13.8396Z",
    fill: "#663718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1507 30.3332L50.7949 29.7441H62.6015L63.9573 30.3332H52.1507Z",
    fill: "#663718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6546 57.5975L37.2988 57.0084L42.8905 38.4922L44.2463 39.0812L38.6546 57.5975Z",
    fill: "#663718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4964 39.0803L35.1406 38.4913L41.4865 12.6846L43.4314 13.5296L36.4964 39.0803Z",
    fill: "#663718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9575 30.3329L38.6551 57.5974L44.2468 39.0811H36.4971L42.8429 13.2744H62.8264L52.1509 30.3329H63.9575Z",
    fill: "url(#paint2_linear_4786_67526)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_4786_67526",
    x: 14.8555,
    y: 5.91529,
    width: 69.3984,
    height: 81.9735,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.0017
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4786_67526"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.30187
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.120431 0 0 0 0 0.2 0 0 0 0 0.0225 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4786_67526",
    result: "effect2_dropShadow_4786_67526"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4786_67526",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4786_67526",
    x: 27.6364,
    y: 7.88185,
    width: 43.8259,
    height: 59.9216,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.70153
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75212
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.176471 0 0 0 0 0.278431 0 0 0 0 0.101961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "color-dodge",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4786_67526"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4786_67526",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4786_67526",
    x1: 43.996,
    y1: 5.78044,
    x2: 49.5548,
    y2: 94.0151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39A5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4601D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4786_67526",
    x1: 49.5554,
    y1: 8.91699,
    x2: 51.6371,
    y2: 80.6777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABE445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43620B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4786_67526",
    x1: 50.1587,
    y1: 23.7089,
    x2: 43.6884,
    y2: 47.7528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6894C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86711"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinDiamondAsset);
export default __webpack_public_path__ + "static/media/spin-diamond-asset.4d48e33a76abdd2475f3e5211bd3d354.svg";
export { ForwardRef as ReactComponent };